import { eventTarget, isInput } from "./dom";

/**
 * Prevents the spacebar from triggering unintended click events when dragging with the mouse.
 *
 * Problem:
 * - By default, holding the spacebar while clicking (or dragging) can trigger unintended
 *   accessibility behaviors, such as focusing elements or simulating a click.
 * - This also prevents spacebar from accidentally opening modals or activating UI elements mid-drag.
 */
export function preventSpacebarClickInterference() {
  let isMousePressed = false;

  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key === " ") {
        if (isMousePressed) {
          e.preventDefault();
          e.stopPropagation();
          const activeEl = document.activeElement as HTMLElement | null;
          if (activeEl) activeEl.blur(); // Prevents focus/outline
        }
      }
    },
    { capture: true },
  );

  const resetMousePress = () => {
    isMousePressed = false;
  };

  document.addEventListener("pointerdown", () => {
    isMousePressed = true;
  });

  document.addEventListener("pointerup", resetMousePress);
  document.addEventListener("pointercancel", resetMousePress);
}

export function disableDefaultContextMenu() {
  document.addEventListener("contextmenu", (e: Event) => {
    if (!isInput(eventTarget(e))) {
      e.preventDefault();
    }
  });
}

export function disableImageDragging() {
  // CSS user-drag: none is not supported by firefox, therefore disable dragging links and images with JS
  document.addEventListener("dragstart", (e) => {
    const targetNode = eventTarget(e).nodeName;
    if (targetNode === "A" || targetNode === "IMG") {
      e.preventDefault();
    }
  });
}
